// src/components/layouts/PublicLayout.jsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import HeaderComponent from '../HeaderComponent'; // Adjust path if needed
import FooterComponent from '../FooterComponent'; // Adjust path if needed
import BottomNav from '../common/BottomNav';
import PullToRefresh from '../common/PullToRefresh';

const PublicLayout = () => {
  const location = useLocation();
  
  const pageVariants = {
    initial: { opacity: 0, x: -10, y: 0 },
    in: { opacity: 1, x: 0, y: 0 },
    out: { opacity: 0, x: 10, y: 0 }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.3
  };

  return (
    <div className="public-layout-wrapper">
      {/* 1. Global Header always stays at the top */}
      <HeaderComponent />

      {/* 2. The Outlet acts as a placeholder where your page content gets injected */}
      <main className="main-content" style={{ minHeight: '80vh', position: 'relative' }}>
        <PullToRefresh>
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={{ width: '100%', height: '100%' }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </PullToRefresh>
      </main>

      {/* 3. Global Footer always stays at the bottom */}
      <FooterComponent />

      {/* 4. Native Mobile Bottom Navigation (only visible on mobile via CSS) */}
      <BottomNav />
    </div>
  );
};

export default PublicLayout;